import { render, staticRenderFns } from "./BlockSelectionPanel.vue?vue&type=template&id=730924bf&scoped=true&"
import script from "./BlockSelectionPanel.vue?vue&type=script&lang=js&"
export * from "./BlockSelectionPanel.vue?vue&type=script&lang=js&"
import style0 from "./BlockSelectionPanel.vue?vue&type=style&index=0&id=730924bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730924bf",
  null
  
)

export default component.exports